export enum GlobalSearchHomeCustomEventsName {
  onClickEditNoteInLuruFromGlobalSearch = 'onClickEditNoteInLuruFromGlobalSearch',
}

interface EditNoteInLuruCustomEventDetail {
  noteId: string
}
